var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrnt"},[_c('img',{attrs:{"src":_vm.imgUrl + 'aliapp/20191012/mianya.jpg',"alt":"大方租车 押金双免"}})])}
var staticRenderFns = []

export { render, staticRenderFns }